import { z } from 'zod'

import {
  emailField,
  passwordField,
} from '@maestro/commerce-blocks/schemas/fields'

export const authSchema = z.object({
  email: emailField,
  password: passwordField,
})
